export default "/assets/images/overreactor-circle.png?a434fc0d33f344ea0b793bceaedef93d";